import { css } from "@emotion/css"

import Header from "./Header/Header"

const Fallback = () => {
  return (
    <div>
      <Header minWidth={1000} maxWidth={1400} />
      <div className={style}>
        <p>問題が発生しました。 ページを再読み込みして、もう一度お試しください。</p>
      </div>
    </div>
  )
}

export default Fallback

const style = css`
  padding-top: 30px;
  text-align: center;
`
